export enum AlertMetric {
  IMPRESSIONS_DROP_PERCENT = 'IMPRESSIONS_DROP_PERCENT',
  REFRESH_DROP_PERCENT = 'REFRESH_DROP_PERCENT',
  REVENUE_DROP_PERCENT = 'REVENUE_DROP_PERCENT',
  REVENUE_DROP_AMOUNT = 'REVENUE_DROP_AMOUNT',
  IMPRESSIONS_STOPPED_DELIVERING = 'IMPRESSIONS_STOPPED_DELIVERING',
  REVENUE_STOPPED_DELIVERING = 'REVENUE_STOPPED_DELIVERING',
  REVENUE_DP_STOPPED_DELIVERING = 'REVENUE_DP_STOPPED_DELIVERING',
}
